import React from 'react';
import { ThemeProvider } from './theme';
import { Footer, Header, ThemeToggle } from './layout';
import { getAllPosts, formatDate, BlogPostPreview } from './blog';
import './theme/globals.css';

/* ─── Blog Post Row ─── */

function BlogPostRow({ post, isLast }: { post: BlogPostPreview; isLast: boolean }) {
  return (
    <a
      href={`/blog/${post.slug}`}
      className="group block"
    >
      <div className="grid grid-cols-1 md:grid-cols-[9rem_1fr] gap-0.5 md:gap-8 items-baseline py-5 md:py-6">
        <time className="text-small text-foreground-muted whitespace-nowrap">
          {formatDate(post.date)}
        </time>
        <h2 className="font-display text-[19px] leading-[1.4] tracking-[-0.3px] text-foreground group-hover:text-foreground-secondary transition-colors">
          {post.title}
        </h2>
      </div>
      {!isLast && (
        <div className="h-px bg-border-subtle" />
      )}
    </a>
  );
}

/* ─── Main Blog Content ─── */

function BlogContent() {
  const allPosts = getAllPosts();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <ThemeToggle />

      <main className="pt-28 sm:pt-36 pb-20 sm:pb-28">
        <div className="max-w-[680px] mx-auto px-6 sm:px-8">
          <h1 className="font-display text-[26px] leading-[1.2] tracking-[-0.5px] font-medium text-foreground mb-10 sm:mb-14">
            Research &amp; News
          </h1>

          <div>
            {allPosts.map((post, i) => (
              <BlogPostRow
                key={post.slug}
                post={post}
                isLast={i === allPosts.length - 1}
              />
            ))}
          </div>

          <p className="mt-12 text-small text-foreground-muted">
            For press and media inquiries, please reach out to{' '}
            <a
              href="mailto:hello@sqwish.ai"
              className="text-foreground-tertiary hover:text-foreground underline underline-offset-2 transition-colors"
            >
              hello@sqwish.ai
            </a>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

/* ─── Blog Page Export ─── */

export function BlogPage() {
  return (
    <ThemeProvider defaultTheme="light">
      <BlogContent />
    </ThemeProvider>
  );
}

export default BlogPage;
